import styled from "@emotion/styled"

export const Wrap = styled.div`
  flex-direction: column;
  color: var(--color-white);
`

export const Text = styled.p`
  font: var(--text-540);
  max-width: 360px;
`

export const Feature = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font: var(--text-540);
`

export const Footer = styled.div`
  display: flex;
  gap: 42px;
`
